import type { Account } from './account-view/types';
import { AccountSidebar } from './account-view/AccountSidebar';
import { ViewShell } from './ViewShell';

interface AccountsShellProps {
  children: any;
  // Account sidebar props
  accounts?: Account[];
  selectedAccountId?: string | null;
  search?: string;
  showStarredOnly?: boolean;
  onSelectAccount?: (accountId: string) => void;
  onSearchChange?: (search: string) => void;
  onToggleStarredOnly?: () => void;
  onToggleStar?: (accountId: string) => void;
  isLoadingAccounts?: boolean;
}

/**
 * Shell for the Accounts view mode with account list sidebar.
 * Wraps ViewShell with accounts-specific sidebar content.
 */
export function AccountsShell({
  children,
  accounts = [],
  selectedAccountId = null,
  search = '',
  showStarredOnly = false,
  onSelectAccount,
  onSearchChange,
  onToggleStarredOnly,
  onToggleStar,
  isLoadingAccounts = false,
}: AccountsShellProps) {
  return (
    <ViewShell
      sidebarContent={
        <AccountSidebar
          accounts={accounts}
          selectedAccountId={selectedAccountId}
          search={search}
          showStarredOnly={showStarredOnly}
          onSelectAccount={onSelectAccount || (() => {})}
          onSearchChange={onSearchChange || (() => {})}
          onToggleStarredOnly={onToggleStarredOnly || (() => {})}
          onToggleStar={onToggleStar || (() => {})}
          isLoading={isLoadingAccounts}
        />
      }
    >
      {children}
    </ViewShell>
  );
}

